export default __webpack_public_path__ + "static/b1-ecdedb8e065919ee58fa154644f38534.png";